import { useTranslation } from 'react-i18next';
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import winner1Shot from '../assets/winners-bolton.jpg';
import winner2Shot from '../assets/VFIHA_picture.jpg';
import winner3Shot from '../assets/S.M.I.L.E._Picture.jpg';
import winner4Shot from '../assets/Mini-Palettes-Roses_Picture.jpg';
// import vidScreen from '../assets/winners-screenshot.jpg';
import winnerLogo from '../assets/winners-ph.png';
import winnerPlaceholder from '../assets/winners-ph-sticks.jpg';
import winnerLogo1 from '../assets/winners-ph-0.png';
import winnerLogo9 from '../assets/winners-ph-1.png';
import winnerLogo6 from '../assets/winners-ph-2.png';
import winnerLogo5 from '../assets/Association-du-hockey-mineur-du-Rocher_Logo.png';
import winnerLogoG1 from '../assets/VFIHA_Logo.png';
import winnerLogo3 from '../assets/Take-A-Shot_Logo.png';
import winnerLogoG2 from '../assets/S.M.I.L.E._Logo.png';
import winnerLogo2 from '../assets/North-Bay-North-Stars_logo.jpg';
import winnerLogoG3 from '../assets/Mini-Palettes-Roses_logo.png';
import winnerLogo4 from '../assets/London-Blizzard-Sledge-Hockey_logo.png';
import winnerLogo7 from '../assets/Hockey-Mineur-Huntingdon_Logo.png';
import winnerLogo8 from '../assets/Hockey-Mineur-Mont-Joli_logo.png';

import winner1Shot26 from '../assets/2026/temiskaming.jpg';
import winner2Shot26 from '../assets/2026/wolverines.jpg';
import winner3Shot26 from '../assets/2026/riverview.jpg';
import winner4Shot26 from '../assets/2026/jusquaubourg.jpg';
// import vidScreen from '../assets/winners-screenshot.jpg';
import winnerLogo126 from '../assets/2026/temiskaming.png';
import winnerLogo226 from '../assets/2026/wolverines-logo.jpg';
import winnerLogo326 from '../assets/2026/riverview-logo.jpg';
import winnerLogo426 from '../assets/2026/jusquauborg-logo.jpg';
import winnerLogo526 from '../assets/2026/vikings.png';
import winnerLogo626 from '../assets/2026/tghl.png';
import winnerLogo726 from '../assets/2026/christie.jpg';
import winnerLogo826 from '../assets/2026/nextshift.jpg';
import winnerLogo926 from '../assets/2026/chaseminor.jpg';
import winnerLogo1026 from '../assets/2026/sportability.png';
import winnerLogo1126 from '../assets/2026/northstar.jpg';
import winnerLogo1226 from '../assets/2026/westhants.png';
import winnerLogo1326 from '../assets/2026/charlesbourg.png';
import winnerLogo1426 from '../assets/2026/sharks.png';

// import hero from '../assets/recipients-hero.jpg';

import gdlogo from '../assets/NHLPA-GD-logo.png';
import gdlogo_fr from '../assets/NHLPA-GD-logo-fr.png';

// import posterImg from '../assets/video-poster-play.jpg';

import canada from '../assets/canada.png';
import cookie from '../assets/cookie.png';

import still from '../assets/recipients-vid-still.jpg';

const gpShots = {
    "2025" : [ winner1Shot, winner2Shot, winner3Shot, winner4Shot ],
    "2026": [ winner1Shot26, winner2Shot26, winner3Shot26, winner4Shot26 ]
};
const gpLogos = {
    "2025" : [ winnerLogo, winnerLogoG1, winnerLogoG2, winnerLogoG3 ],
    "2026": [ winnerLogo126, winnerLogo226, winnerLogo326, winnerLogo426 ]
};
const wLogos = {
    "2025" : [ winnerLogo1, winnerPlaceholder, winnerLogo2, winnerLogo3, winnerLogo4, winnerLogo5, winnerLogo6, winnerLogo7, winnerLogo8, winnerLogo9 ],
    "2026": [ winnerLogo526, winnerLogo626, winnerLogo726, winnerLogo826, winnerLogo926, winnerLogo1026, winnerLogo1126, winnerLogo1226, winnerLogo1326, winnerLogo1426 ]
};
const wPos = [
    [980, 1079], // toronto, on // 2025 grands
    [149,876], // vancouver, bc
    [1241,922], // wolfville, ns
    [1031, 932], // val morin, qc
    [133, 457], // yukon // 2025 winners
    [780,920], // fort hope
    [955,1030], // north bay
    [915,1144], // windsor
    [965,1114], // london
    [1190,846], // chandler, qc
    [1091, 952], // montreal, qc
    [1064, 993], // hinchinbrooke, qc
    [1145,836], // mont joli, qc
    [1225,896], // dieppe, nb
    [932,980], // temiskaming shores, on // 2026 grands
    [335,885], // calgary, ab
    [1215,899], // riverview, nb,
    [1096, 957], // montreal, qc
    [985, 1084], // toronto, on // 2026 winners
    [990, 1089], // toronto, on
    [1017, 1033], // ottawa, on
    [440,850], // meadowlake sk
    [235,876], // chase bc
    [154,881], // van bc
    [1247,866], // rustico pei
    [1253,930], // windsor ns
    [1119,886], // qc qc
    [1112,922], // aston-jonction qc
]


export default function Recipients(){
    const { t, i18n } = useTranslation();

    // const navigate = 
    const [ year, setYear ] = useState("2026");

    const getWinnerImage = (i) => {
        let imgClass = '';
        // if (i<4) imgClass += 'v-thumb'
        return <img src={gpShots[year][i]} alt={t(`recipients.grandprize.${year}.winner${i}.name`)} className={imgClass} />; // onClick={()=>handleWinnerVidClick(i)} />
    }
    const getWinnerLogo = (i) => {
        let imgClass = 'logo';
        return <img src={gpLogos[year][i]} alt={t(`recipients.grandprize.${year}.winner${i}.name`)} className={imgClass} />
    }

    const getMapLogo = (i) => {
        const myear = i>=14 ? "2026" : "2025";
        const fi = i%14;
        if (fi<4) { 
            return gpLogos[myear][fi]
        } else {
            return wLogos[myear][fi-4];
        }
    }
    const getMapLabel = (i) => {
        const myear = i>=14 ? "2026" : "2025";
        const fi = i%14;
        if (fi<4) { 
            return t(`recipients.grandprize.${myear}.winner${fi}.name`)
        } else {
            return t(`recipients.winners.${myear}.winner${fi-4}`)
        }
    }


    return (
        <Container fluid as='main' className="recipients light-blue-bg">
            <Row className="justify-content-center">
                
                {/* <img src={hero} alt={t('recipients.title')} className='video-bg' /> */}
                <Col xs={12} sm={10} xxl={8} className="text-sm-center px-4 pb-4">
                    <h1>{t('recipients.title')}</h1>

                </Col>
                <Col xs={12} sm={10} className="">
                    <video className="" controls playsInline poster={still}>
                        <source src={t('recipients.videopath')} type="video/mp4"></source>
                    </video>
                </Col>

                <Col className="" xs={12}>
                    <Container className="map">
                        <img src={canada} alt="Canada" className="" />
                        {wPos.map((pos, i) =>
                            <div key={i} className="cookie-ph" style={{left:pos[0]/14.34+'%',top:pos[1]/11.80+'%'}}> 
                                <img src={cookie} alt={t('recipients.winners.label')} className="cookie" />
                                <div className="bubble">
                                    <img src={getMapLogo(i)} alt={getMapLabel(i)} className="logo" />
                                    <p className="my-0 fw-normal">{getMapLabel(i)}</p>
                                </div>
                            </div>
                        )}
                        
                        
                    </Container>
                    <Container>
                        <p className="map-instruct">{t('recipients.winners.desc')}</p>
                    </Container>
                </Col>
            </Row>

            <Row className="skinny-row">
                <Col className="text-sm-center my-5">
                    <h3>{t('recipients.subtitle')}</h3>
                    <p>{t('recipients.body')}</p>
                    
                    <div className="mt-5 year-tabs text-center">
                        <button onClick={()=>setYear("2026")} disabled={year==="2026"}>{t('recipients.winners.2026.recipients')}</button>
                        <button onClick={()=>setYear("2025")} disabled={year==="2025"}>{t('recipients.winners.2025.recipients')}</button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    {/* <video className="video-box container" playsInline controls poster={posterImg}>
                        <source src={t('homepage.videopath')} type="video/mp4"></source>
                    </video> */}
                    <h2>{t('recipients.grandprize.title')}</h2>
                </Col>
            </Row>
            {[...Array(4)].map((x, i) =>
                <Row key={i}>
                    <Col>
                        <Container className={`player-box my-4 py-3 p-sm-5`}>
                            <Row className="align-items-center">
                                <Col className={`text-white z-1 d-flex flex-column flex-sm-row align-items-center justify-content-center gap-sm-4 ${i%2===0 && "order-sm-1"}`}>
                                    <div className={`p-thumb order-last ${i%2===0?"order-sm-first":"order-sm-end"}`}>
                                    {getWinnerImage(i)}
                                    </div>
                                    <div className="d-flex flex-column">
                                        {getWinnerLogo(i)}
                                        <h2 className="">{t(`recipients.grandprize.${year}.winner${i}.name`)}</h2>
                                        {/* <h3 className="mt-0 text-purple">{t(`recipients.grandprize.label`)}</h3> */}
                                        <p dangerouslySetInnerHTML={{__html:t(`recipients.grandprize.${year}.winner${i}.body`)}}></p>
                                    </div>
                                </Col>
                        </Row>
                        </Container>
                    </Col>
                </Row>
            )}

            <Row className='justify-content-center container mx-auto'>
                <Col className="text-sm-center mt-5" xs={12}>
                    <h2>{t('recipients.winners.title')}</h2>
                </Col>
                {[...Array(10)].map((x, i) =>
                    <Col key={i} className="" xs={12} sm={4}>
                        {/* <div className={`p-thumb order-last ${i%2===1?"float-start ":"float-end"}`}>
                        {getPlayerImage(i)}
                        </div> */}
                        <div className="d-flex flex-row flex-sm-column gap-4 text-sm-center p-2 p-sm-4 p-xl-8 winner align-items-center mb-4">
                            <img src={wLogos[year][i]} alt={t(`recipients.winners.${year}.winner${i}`)} className="logo" />
                            <h4 className="my-0 fw-normal">{t(`recipients.winners.${year}.winner${i}`)}</h4>
                            {/* <h4 className="mt-0">{t(`recipients.winners.label`)}</h4> */}
                        </div>
                    </Col>
                )}
                
            </Row>
            <Row>
                <Col className="text-center mb-4">
                    <img src={i18n.resolvedLanguage === 'fr' ? gdlogo_fr : gdlogo} alt="NHLPA Goals & Dreams - est. 1999" className="nhlpa-logo" />
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col className="text-center">
                    <p dangerouslySetInnerHTML={{__html:t('teamoreo.sub')}} />
                    <Link to="/about" className="button">{t('teamoreo.cta')}</Link>
                </Col>
            </Row>

        </Container>
    );
}